module.exports = __webpack_public_path__ + "media/images/default/join_us/recruit_ipad-8ebf5335c50dcd353e02e87ebd49b204.jpg";